'use client';
import { createContext, PropsWithChildren, useContext } from 'react';
import useSWR, { Key } from 'swr';
import { ServerActionError } from '@core-systems/http';
import { CurrentApplicantResult } from '@apply/server-actions/results/current-applicant.result';
import { fetcher } from '@apply/utils/fetcher';

export function currentApplicantKey(): Key {
  return '/v1/apply/applicants/me';
}

type CurrentApplicantContextType = {
  applicant: CurrentApplicantResult | undefined;
  isLoading: boolean;
  error: ServerActionError | undefined;
};

const CurrentApplicantContext = createContext<CurrentApplicantContextType>({
  applicant: undefined,
  isLoading: true,
  error: undefined,
});

export const CurrentApplicantProvider = ({ children }: PropsWithChildren): React.JSX.Element => {
  const {
    data: applicant,
    isLoading,
    error,
  } = useSWR<CurrentApplicantResult>(currentApplicantKey(), (url: string) => fetcher<CurrentApplicantResult>(url));

  return (
    <CurrentApplicantContext.Provider value={{ applicant, isLoading, error }}>
      {children}
    </CurrentApplicantContext.Provider>
  );
};

export function useCurrentApplicant(): CurrentApplicantContextType {
  return useContext(CurrentApplicantContext);
}
